// extracted by mini-css-extract-plugin
export default {"container":"cF-z","modal":"dF-z","dimensions":"eF-z","brandName":"fF-z","productName":"gF-z","labelValue":"hF-z","recipientEmail":"iF-z","recommendedFit":"jF-z","hiddenField":"kF-z"};